import React from "react";
import {HelpFileRepository} from "../../../repository";
import {HelpFile} from "../../../model";
import {EntityReadTemplate} from "../../../component/template/EntityReadTemplate";
import {Downloader} from "../../../component/Downloader";
import {Attribute} from "../../../component/Attribute";

export const ReadHelpFile = () => {

    return (
        <EntityReadTemplate<HelpFile>
            repository={new HelpFileRepository()}
            title={{
                page: `Document (Aide en ligne)`,
                schema: `$0`,
                params: [`name`]
            }}
            attributes={[
                { label: `Nom`, key: 'name' },
                { label: `Description`, key: 'description' },
                { label: `Version`, key: 'version' },
                { label: `Répertoire`, key: 'directory.name' },
                { label: `Permission`, key: 'permission' },
            ]}
        >
            {
                (data: HelpFile) => {
                    switch (data.type) {
                        case 'file':
                            return <Attribute label={'Fichier'} value={<Downloader id={data.id} type={'help'} filename={data.name} version={data.version}/>}/>
                        case 'video':
                            return <Attribute label={`Vidéo`} value={<a href={data.helpUrl} target={`_blank`}>{`Lien vers la vidéo`}</a>}/>
                    }
                }
            }
        </EntityReadTemplate>
    )
}